import { useAuth } from 'context/AuthProvider'
import React, { useEffect, useState } from 'react'
import { Card, CardHeader, Table } from 'reactstrap'
import { apiAusenciasService } from 'services/apiAusenciasService'

const IncidenciasEnVacaciones = () => {
    const {empresa} = useAuth();
    const year = new Date().getFullYear();

    const [incidenciaVacaciones, setIncidenciasVacaciones] = useState([])


    useEffect(() => {
        const fetchData = async () =>{
            const response = await apiAusenciasService.getIncidenciasVacaciones(empresa.id,year )
            setIncidenciasVacaciones(response)
        }

        fetchData()

        

    
      return () => {
        
      }
    }, [year, empresa.id])
    


  return (
    <>
        {incidenciaVacaciones.length> 0  &&
         <Card Card style={{borderColor:'red'}}>
                <CardHeader >
                    Existen incidencias en las vacaciones
                </CardHeader>
                    <Table className='text-center table-flush' responsive>
                        <thead className='thead-light'>
                        <th>Apellidos</th>
                        <th>Nombre</th>
                        <th>Vacaciones actuales</th>
                        <th>Vacaciones permitidas</th>
                        </thead>
                        <tbody>
                            {incidenciaVacaciones.map(incidencia =>(
                                <tr key={incidencia.id}>
                                    <td>{incidencia.apellidos}</td>
                                    <td>{incidencia.nombre}</td>
                                    <td className='text-danger'>{incidencia.vacacionesActuales}</td>
                                    <td>{incidencia.vacacionesPermitidas}</td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

               

            </Card>
        }
    </>
  )
}

export default IncidenciasEnVacaciones